export default __webpack_public_path__ + "static/media/sidebarlogotag.59a660fa.svg";